import { executeRequest, JFSRequest } from '@jfs/network'
import {
  dateFormatter,
  DateFormatTypes,
  fromDateTime,
  getAcceptableStatus,
  isSuccessResponse,
  toDateTime,
} from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const parser = (dataList: any) => {
  let parsedList: any[] = []
  console.log('dataList', dataList)
  dataList?.map(
    ({
      groupDto,
      entityDto,
      createdAt,
      requestType,
      applicationState,
      applicationId,
      applicationType,
      identificationNumber,
      comments,
      errorReason,
    }) => {
      const data = groupDto || entityDto
      parsedList.push({
        legalName: data?.legalName,
        creationDate: dateFormatter(createdAt, DateFormatTypes.TIME_STAMP),
        mobileNumber: data?.groupContacts?.[0]?.mobileNumber ?? data?.contactDetails?.[0]?.mobileNumber ?? 'NA',
        requestType: data?.type,
        status: applicationState,
        isSelected: false,
        //assignee: data?.assignee,
        applicationId: applicationId,
        groupAddress: data?.groupAddress,
        groupContacts: data?.groupContacts,
        type: requestType,
        brandName: data?.brandName,
        businessName:
          applicationType === 'GROUP_ADD' || applicationType === 'SUBGROUP_ADD' ? data?.brandName : data?.businessName,
        addressDetails: data?.addressDetails,
        contactDetails: data?.contactDetails,
        identificationNumber: identificationNumber,
        gstDetails: data?.gstDetails,
        settlementDetails: data?.settlementDetails,
        feePackageDetails: data?.feePackageDetails,
        programCategoryDetails: data?.programCategoryDetails,
        deviceDetails: data?.deviceDetails,
        businessProfile: data?.businessProfile,
        source: data?.source,
        parentEntityIdentificationNumber: data?.parentEntityIdentificationNumber,
        subGroupIdentificationNumber: data?.subGroupIdentificationNumber,
        applicationStatus: applicationState === 'Pending' ? 'Pending For Approval' : applicationState,
        errorReason: errorReason,
        errorTask: data?.errorTask,
        inProgressTask: data?.inProgressTask,
        completedTaskList: data?.completedTaskList,
        applicationType: applicationType,
        comments: comments,
        terminalDetails: data?.terminalDetails,
        jfsUserid: data?.jfsUserid,
        uploadId: data?.uploadId,
      })
    },
  )
  return parsedList
}

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  console.log('data', data?.processInstances)
  return {
    list: parser(data?.processInstances),
    pagination: {
      size: data?.pageSize,
      totalElements: data?.totalItems ?? 1,
      number: data?.pageNumber,
      totalPages: Math.ceil(data?.totalItems / data?.pageSize),
    },
  }
}

const getMakerListReq = (
  selectedDateInfo: any,
  pagination: any,
  applicationStatus: any,
  tokens: any,
  searchBy?: string,
  searchKey?: string,
) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.makerApplicationQueue),
    method: 'POST',
    cache: false,
    body: {
      configParams: {
        page: searchBy && searchBy?.length > 0 && searchKey?.length > 0 ? 1 : pagination.number,
        recordCount: 10,
      },
      inputFilters: {
        endDateTime:
          selectedDateInfo.toDate !== new Date(Date.now())
            ? toDateTime(new Date(Date.now()))
            : toDateTime(selectedDateInfo.toDate),
        startDateTime: fromDateTime(selectedDateInfo.fromDate),
        ...(applicationStatus.length > 0 &&
          !applicationStatus?.includes('ALL') && {
            status: getAcceptableStatus(applicationStatus),
          }),
        ...(searchBy?.length > 0 && searchKey?.length > 0 && { [searchBy]: searchKey }),
      },
    },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getMakerListReq }
